import { CoachingRole } from '../coaching-base/general';
import { EventParticipantDto } from '../coaching-base/general/event-participant-observation-dto.model';

export function determineNotificationAddress(
    userId: number,
    performer: EventParticipantDto,
    observer: EventParticipantDto,
): {
    from: number;
    to: number;
} {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    performer = performer || ({} as EventParticipantDto);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    observer = observer || ({} as EventParticipantDto);

    // until some other participant role is expected, observer -> performer is the default
    let fromWhich = CoachingRole.OBSERVER;
    let toWhich = CoachingRole.PERFORMER;
    if (observer.userId === performer.userId) {
        fromWhich = CoachingRole.PERFORMER;
        toWhich = CoachingRole.OBSERVER;
    }

    const idForRole = (roleId: CoachingRole): number => {
        switch (roleId) {
            case CoachingRole.PERFORMER:
                return performer.userId;
            case CoachingRole.OBSERVER:
                return observer.userId;
            default:
                return userId;
        }
    };

    return { from: idForRole(fromWhich), to: idForRole(toWhich) };
}
